<script>
	export default {
		name: 'DebugExecuter',
		methods: {
			debugMakeIpcEnv() {
				const self_ = this;

				const resetPassword_ = {
					isCollapsedMenu: true,
					isMobileMenu: true,
					menu: { menu: true },
					order: 5,
					title: 'Reset Password',
					icon: 'person',
					link: { to : '/reset-password' },
					menuGroup: { all : true },
					securityGroup: {
						user : true,
						admin : true
					}						
				}
				const securityQuestion_ = {
					isCollapsedMenu: true,
					isMobileMenu: true,
					menu: { menu: true },
					order: 6,
					title: 'Security Question',
					icon: 'how_to_reg',
					link: { to : '/security-question' },
					menuGroup: { all : true },
					securityGroup: {
						user : true,
						admin : true
					}						
				}

				const link_ = {
					pageTitleButton: {
						nonUser: {
							to: '/login'
						},
						user: {
							to: '/point',
							method: {
								name: 'switchMenuGroup',
								params: { menuGroup: 'point' }
							}
						}
					}
				}

				const lang_ = {
					pageTitleButton: {
						nonUser: 'Login',
						user: 'Start'
					}	
				}

				let promiseArray_ = []
				promiseArray_.push(self_.firebase.firestore().collection('contents').doc('app').collection('languages').doc('ja').set({ order: null }))
				promiseArray_.push(self_.firebase.firestore().collection('contents').doc('app').collection('languages').doc('id').set({ order: null }))
				promiseArray_.push(self_.firebase.firestore().collection('contents').doc('app').collection('themes').doc('dark').set({ order: null, isDefault: false }))
				promiseArray_.push(self_.firebase.firestore().collection('contents').doc('app').collection('themes').doc('light').set({ isDefault: true }))
				promiseArray_.push(self_.firebase.firestore().collection('contents').doc('app').collection('menuItems').doc('index').set({ order: null }))
				promiseArray_.push(self_.firebase.firestore().collection('contents').doc('app').collection('menuItems').doc('point').set({ order: null }))
				promiseArray_.push(self_.firebase.firestore().collection('contents').doc('app').collection('menuItems').doc('recruit').set({ order: null }))
				promiseArray_.push(self_.firebase.firestore().collection('contents').doc('app').collection('menuItems').doc('sales').set({ order: null }))
				promiseArray_.push(self_.firebase.firestore().collection('contents').doc('app').collection('menuItems').doc('training').set({ order: null }))
				promiseArray_.push(self_.firebase.firestore().collection('contents').doc('app').collection('menuItems').doc('profile').set({ order: null }))
				promiseArray_.push(self_.firebase.firestore().collection('contents').doc('app').collection('menuItems').doc('news').set({ order: null }))
				promiseArray_.push(self_.firebase.firestore().collection('contents').doc('app').collection('menuItems').doc('tutorial').set({ order: null }))
				promiseArray_.push(self_.firebase.firestore().collection('contents').doc('app').collection('menuItems').doc('timeline').set({ order: null }))
				promiseArray_.push(self_.firebase.firestore().collection('contents').doc('app').collection('menuItems').doc('resetPassword').set(resetPassword_))
				promiseArray_.push(self_.firebase.firestore().collection('contents').doc('app').collection('menuItems').doc('securityQuestion').set(securityQuestion_))
				promiseArray_.push(self_.firebase.firestore().collection('contents').doc('component').collection('toolbar').doc('services').set({ order: null }))
				promiseArray_.push(self_.firebase.firestore().collection('inits').doc('page').collection('index').doc('link').set(link_))
				promiseArray_.push(self_.firebase.firestore().collection('inits').doc('page').collection('index').doc('lang').set(lang_))
				promiseArray_.push(self_.firebase.firestore().collection('inits').doc('page').collection('login').doc('lang').set({ signUpButton: null }))

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return Promise.all(promiseArray_)
					}).then(() => {
						self_.setDebugState('result', ['finihsed'])
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			debugAddAdminUser() {
				const self_ = this;

				const auth_ = {
					uid: 'admin',
					email: 'boid.dev.app+' + self_.appId + '-admin@gmail.com',
					phoneNumber: '+16505550000',
					password: 'qwertyQWERTY123456' // The password must be a string with at least 6 characters.
				}

				const data_ = {
					group: 'admin',
					username: 'admin',
					email: 'boid.dev.app+' + self_.appId + '-admin@gmail.com'
				}

				let result_ = []

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.callFunction('authFunction', 'postSignUp', { body: auth_ })
					}).then(result => {
						result_.push(result)
						return self_.setFirestoreDocument('users', 'admin', data_)
					}).then(result => {
						result_.push(result)

						self_.setDebugState('result', result_)

						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			debugResetUser() {
				const self_ = this;

				const delete_ = uid => {
					return self_.firebase.firestore().collection('users').doc(uid).delete()
				}

				let promiseArray_ = []

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.getFirestoreCollection('users')
					}).then(result => {
						Object.keys(result).forEach(key => {
							if(key != 'admin') {
								promiseArray_.push(delete_(key))
							}
						})
						return Promise.all(promiseArray_)
					}).then(() => {
						self_.setDebugState('result', ['finihsed'])
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			debugMoveUsersToLaravel() {
				const self_ = this;

				let data_ = self_.getDebugState('data') // data = [ 'uid' ]

				let result_ = []

				const move_ = uid => {
					let user_ = {}
					let usernameIpc_ = null;
					let oldSystemClientUserId_ = null;

					return new Promise((resolve, reject) => {
						Promise.resolve().then(()=> {
/* dev */					self_.logDev('Move User To Laravel', 'Getting user document...', { uid: uid })

							return self_.getFirestoreDocument('users', uid)
						}).then(result => {
							if(self_.isEmpty(result)) {
								reject('user document does not exist. (' + uid + ')')
							} else {
								user_ = result;
								// custom for bri life start
								if(user_.group == 'ibs' || user_.group == 'adminibs') {
									usernameIpc_ = user_.username + '_' + self_.ipcDomain + '-ibs';	
								}
								else if(user_.group == 'agency' || user_.group == 'adminagency') {
									usernameIpc_ = user_.username + '_' + self_.ipcDomain + '-agency';	
								}
								else {
									usernameIpc_ = user_.username + '_' + self_.ipcDomain;	
								}
								// custom for bri life start

/* dev */						self_.logDev('Move User To Laravel', 'Checking client users...', { username: usernameIpc_ })

								return self_.$_debugExec_call('ipcFunction', 'getClientUsers', { username: usernameIpc_ })
							}
						}).then(result => {
							if(!self_.isEmpty(result)) { oldSystemClientUserId_ = result[0].id; }

/* dev */					self_.logDev('Move User To Laravel', 'Checking app users...', { uid: uid })

							return self_.$_debugExec_call('ipCliFunction', 'getAppUsers', { uid: uid })
						}).then(result => {
							const body_ = {
								uid: uid,
								username: user_.username,
								fullName: user_.fullName || user_.displayName || user_.username,
								email: user_.email || null,
								phone: user_.phone || null,
								postcode: null,
								address1: null,
								address2: null,
								profilePictureUrl: null,
								userGroupCode: 'all',
								userGroupName: 'All Users',
								securityGroupCode: 'user',
								securityGroupName: 'User',
								blocked: false,
								disabled: false,
								oldSystemClientUserId: oldSystemClientUserId_
							}

							if(self_.isEmpty(result)) {
/* dev */						self_.logDev('Move User To Laravel', 'Storing app users...', { result: result, body: body_ })

								return self_.$_debugExec_call('ipCliFunction', 'postAppUsers', body_)
							} else {
/* dev */						self_.logDev('Move User To Laravel', 'Updating app users...', { result: result, body: body_ })

								return self_.$_debugExec_callById('ipCliFunction', 'putAppUsers', result[0].id, body_)
							}
						}).then(() => {
/* dev */					self_.logDev('Move User To Laravel', 'Checking app user options...', { uid: uid })

							return self_.$_debugExec_call('ipCliFunction', 'getAppUserOptions', { uid: uid })
						}).then(result => {
							const resetPassword_ = user_.resetPassword || false;
							const resetSecurityQuestion_ = user_.securityQuestion || false;

							const body_ = {
								uid: uid,
								resetPassword: resetPassword_,
								resetSecurityQuestion: resetSecurityQuestion_
							}

							if(self_.isEmpty(result)) {
/* dev */						self_.logDev('Move User To Laravel', 'Storing app user options...', { result: result, body: body_ })

								return self_.$_debugExec_call('ipCliFunction', 'postAppUserOptions', body_)
							} else {
/* dev */						self_.logDev('Move User To Laravel', 'Updating app user options...', { result: result, body: body_ })

								// return self_.$_debugExec_callById('ipCliFunction', 'putAppUserOptions', result[0].id, body_)
								return Promise.resolve()
							}
						}).then(() => {
/* dev */					self_.logDev('Move User To Laravel', 'Checking app user groups...', { uid: uid })

							return self_.$_debugExec_call('ipCliFunction', 'getAppUserGroups', { uid: uid, groupCode: 'all' })
						}).then(result => {
							const body_ = {
								uid: uid,
								groupCode: 'all',
								groupName: 'All Users'
							}

							if(self_.isEmpty(result)) {
/* dev */						self_.logDev('Move User To Laravel', 'Storing app user groups...', { result: result, body: body_ })

								return self_.$_debugExec_call('ipCliFunction', 'postAppUserGroups', body_)
							} else {
/* dev */						self_.logDev('Move User To Laravel', 'Updating app user groups...', { result: result, body: body_ })

								// return self_.$_debugExec_callById('ipCliFunction', 'putAppUserGroups', result[0].id, body_)
								return Promise.resolve()
							}
						}).then(() => {
/* dev */					self_.logDev('Move User To Laravel', 'Checking app user point data...', { uid: uid })

							return self_.$_debugExec_call('ipCliFunction', 'getAppUserPointData', { uid: uid })
						}).then(result => {
							const body_ = {
								uid: uid,
								pointGivingAmount: 0,
								pointRedemptionAmount: 0,
								pointReturnAmount: 0,
								pointCancellationAmount: 0,
								pointExpirationAmount: 0
							}

							if(self_.isEmpty(result)) {
/* dev */						self_.logDev('Move User To Laravel', 'Storing app user point data...', { result: result, body: body_ })

								return self_.$_debugExec_call('ipCliFunction', 'postAppUserPointData', body_)
							} else {
/* dev */						self_.logDev('Move User To Laravel', 'Updating app user point data...', { result: result, body: body_ })

								return self_.$_debugExec_callById('ipCliFunction', 'putAppUserPointData', result[0].id, body_)
								// return Promise.resolve()
							}
						}).then(() => {
/* dev */					self_.logDev('Move User To Laravel', 'Moved...', { uid: uid })

							result_.push(uid + ' -> moved')

							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				let promiseSequence_ = Promise.resolve()

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						if(self_.isEmpty(data_)) {
							return self_.getFirestoreCollection('users', {}, 0)
						} else {
							return Promise.resolve()
						}
					}).then(result => {
/* dev */				self_.logDev('Move User To Laravel', 'Started to check.')

						if(self_.isEmpty(data_)) { data_ = Object.keys(result) }

						return new Promise((resolve, reject) => {
							data_.forEach(uid => {
								promiseSequence_ = promiseSequence_.then(() => { return move_(uid) })
							})
							promiseSequence_ = promiseSequence_.then(() => resolve()).catch(error => reject(error))
						})
					}).then(() => {
/* dev */				self_.logDev('Move User To Laravel', 'Finished.')

						self_.setDebugState('result', result_)

						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			debugMovePointToLaravel() {
				const self_ = this;

				const data_ = self_.getDebugState('data')
				// data = {
				//		pointGiving: [ 'uid' ],
				//		pointReturn: [ 'uid' ],
				//		pointRedemption: [ 'uid' ],
				//		pointCancellation: [ 'uid' ],
				//		pointExpiration: [ 'uid' ]
				// }

				const today_ = self_.formatDate(new Date(), 'YYYY-MM-DD')
				const oneYearFromToday_ = self_.formatDate(self_.addYear(new Date(), 1), 'YYYY-MM-DD')
				const yesterday_ = self_.formatDate(self_.addDay(new Date(), -1), 'YYYY-MM-DD')
				const endForever_ = '2999-12-31';

				let result_ = []

				const pointGiving_ = uid => {
					const move_ = pointGivingData => {
						return new Promise((resolve, reject) => {
							let pointCriterium_ = {}

							Promise.resolve().then(() => {
/* dev */						self_.logDev('Point Giving (Moving)', 'Getting point givings...', { oldSystemPointGivingId: pointGivingData['id'] })

								return self_.$_debugExec_call('ipCliFunction', 'getPointGivings', { oldSystemPointGivingId: pointGivingData['id'] })
							}).then(result => {
								const body_ = {
									uid: uid,
									amount: pointGivingData['point_given'],
									startDate: pointGivingData['authorize_date'],
									endDate: pointGivingData['expired_date'],
									pointCriteriumCode: pointGivingData['point_criteria_id'],
									pointCriteriumName: pointGivingData['point_criteria_name'],
									voucherCode: null,
									voucherName: null,
									description: null,
									oldSystemPointGivingId: pointGivingData['id']
								}

								if(self_.isEmpty(result)) {
/* dev */							self_.logDev('Point Giving (Moving)', 'Storing point givings...', { result: result, body: body_ })

									return self_.$_debugExec_call('ipCliFunction', 'postPointGivings', body_)
								} else {
/* dev */							self_.logDev('Point Giving (Moving)', 'Updating point givings...', { result: result, body: body_ })

									// return self_.$_debugExec_callById('ipCliFunction', 'putPointGivings', result[0].id, body_)
									return Promise.resolve(result[0])
								}
							}).then(result => {
								result_.push('Finished: uid = ' + uid + ' / point giving id = ' + pointGivingData['id'] + ' -> ' + result.id)

								resolve()
							}).catch(error => {
								reject(error)
							})
						})
					}

					const expire_ = expiredPoint => {
						return new Promise((resolve, reject) => {
							Promise.resolve().then(() => {
/* dev */						self_.logDev('Point Giving (Expiring)', 'Getting point expirations...', { uid: uid, startDate: today_ })

								return self_.$_debugExec_call('ipCliFunction', 'getPointExpirations', { uid: uid, startDate: today_ })
							}).then(result => {
								const body_ = {
									uid: uid,
									amount: expiredPoint,
									startDate: today_,
									endDate: endForever_,
									description: null
								}

								if(self_.isEmpty(result)) {
/* dev */							self_.logDev('Point Giving (Expiring)', 'Storing point expirations...', { result: result, body: body_ })

									return self_.$_debugExec_call('ipCliFunction', 'postPointExpirations', body_)
								} else {
/* dev */							self_.logDev('Point Giving (Expiring)', 'Updating point expirations...', { result: result, body: body_ })

									// return self_.$_debugExec_callById('ipCliFunction', 'putPointExpirations', result[0].id, body_)
									return Promise.resolve(result[0])
								}
							}).then(result => {
								result_.push('Finished: uid = ' + uid + ' / id = ' + result.id)
								resolve()
							}).catch(error => {
								reject(error)
							})
						})
					}

					let promiseSequencePointGiving_ = Promise.resolve()

					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
/* dev */					self_.logDev('Point Giving', 'Getting app users...', { uid: uid })
							return self_.$_debugExec_call('ipCliFunction', 'getAppUsers', { uid: uid })
						}).then(result => {
							if(self_.isEmpty(result)) {
								reject('app user does not exist. (' + uid + ')')
							} else if(self_.isFalse(result[0]['old_system_client_user_id'])) {
/* dev */						self_.logDev('Point Giving', 'app user does not have old system client user id...', { uid: uid, result: result })

								return Promise.resolve()
							} else {
								const clientUserId_ = result[0]['old_system_client_user_id']

/* dev */						self_.logDev('Point Giving', 'Getting ipc point giving...', { clientUserId: clientUserId_ })

								return self_.$_debugExec_call('ipcFunction', 'getPointGiving', { clientUserId: clientUserId_ })
							}
						}).then(result => {
							if(self_.isEmpty(result)) {
/* dev */						self_.logDev('Point Giving', 'point giving does not exist...', { uid: uid,  result: result })

								return Promise.resolve()
							} else {
/* dev */						self_.logDev('Point Giving', 'Starting to move...', { uid: uid,  result: result })

								return new Promise((resolve, reject) => {
									let sumExpired_ = 0;

									result.forEach(pointGivingData => {
										promiseSequencePointGiving_ = promiseSequencePointGiving_.then(() => { return move_(pointGivingData) })

										if(pointGivingData['point_status_id'] == '3' && pointGivingData['expired_date'] < today_) {
											sumExpired_ += pointGivingData['point_remaining']
										}
									})
									promiseSequencePointGiving_ = promiseSequencePointGiving_.then(() => { return expire_(sumExpired_) })
									promiseSequencePointGiving_ = promiseSequencePointGiving_.then(() => resolve()).catch(error => reject(error))
								})
							}
						}).then(() => {
							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				const pointRedemption_ = uid => {
					const move_ = itemOrderData => {
						let purchaseOrder_ = {}

						return new Promise((resolve, reject) => {
							Promise.resolve().then(() => {
/* dev */						self_.logDev('Point Redemption (Moving)', 'Getting purchase orders...', { oldSystemItemOrderId: itemOrderData['id'] })

								return self_.$_debugExec_call('ipCliFunction', 'getPurchaseOrders', { oldSystemItemOrderId: itemOrderData['id'] })
							}).then(result => {
								const body_ = {
									datetime: itemOrderData['created'],
									uid: uid,
									supplierCode: 'temp',
									productCode: 'temp',
									unitPrice: 0,
									quantity: 0,
									productPoint: 0,
									shippingPoint: 0,
									insurancePoint: 0,
									totalPoint: 0,
									oldSystemItemOrderId: itemOrderData['id']
								}

								if(self_.isEmpty(result)) {
/* dev */							self_.logDev('Point Redemption (Moving)', 'Storing purchase orders...', { result: result, body: body_ })

									return self_.$_debugExec_call('ipCliFunction', 'postPurchaseOrders', body_)
								} else {
/* dev */							self_.logDev('Point Redemption (Moving)', 'Updating purchase orders...', { result: result, body: body_ })

									// return self_.$_debugExec_callById('ipCliFunction', 'putPurchaseOrders', result[0].id, body_)
									return Promise.resolve(result[0])
								}
							}).then(result => {
								result_.push('Finished: uid = ' + uid + ' / item order id = ' + itemOrderData['id'] + ' -> purchase order id = ' + result.id)

/* dev */						self_.logDev('Point Redemption (Moving)', 'Getting point redemptions...', { oldSystemItemOrderId: itemOrderData['id'] })

								purchaseOrder_ = result;

								return self_.$_debugExec_call('ipCliFunction', 'getPointRedemptions', { oldSystemItemOrderId: itemOrderData['id'] })
							}).then(result => {
								const body_ = {
									uid: uid,
									amount: itemOrderData['point'] + itemOrderData['shipping_point'] + itemOrderData['insurance_point'],
									startDate: itemOrderData['created'],
									endDate: endForever_,
									purchaseOrderId: purchaseOrder_['id'],
									description: null,
									oldSystemItemOrderId: itemOrderData['id']
								}

								if(self_.isEmpty(result)) {
/* dev */							self_.logDev('Point Redemption (Moving)', 'Storing point redemptions...', { result: result, body: body_ })

									return self_.$_debugExec_call('ipCliFunction', 'postPointRedemptions', body_)
								} else {
									const id_ = result[0].id;

/* dev */							self_.logDev('Point Redemption (Moving)', 'Updating point redemptions...', { result: result, body: body_ })

									// return self_.$_debugExec_callById('ipCliFunction', 'putPointRedemptions', id_, body_)
									return Promise.resolve(result[0])
								}
							}).then(result => {
								result_.push('Finished: uid = ' + uid + ' / item order id = ' + itemOrderData['id'] + ' -> point redemption id = ' + result.id)

								resolve()
							}).catch(error => {
								reject(error)
							})
						})
					}
					
					let promiseSequencePointRedemption_ = Promise.resolve()

					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
/* dev */					self_.logDev('Point Redemption', 'Getting app users...', { uid: uid })
							return self_.$_debugExec_call('ipCliFunction', 'getAppUsers', { uid: uid })
						}).then(result => {
							if(self_.isEmpty(result)) {
								reject('app user does not exist. (' + uid + ')')
							} else if(self_.isFalse(result[0]['old_system_client_user_id'])) {
/* dev */						self_.logDev('Point Redemption', 'app user does not have old system client user id...', { uid: uid, result: result })

								return Promise.resolve()
							} else {
								const clientUserId_ = result[0]['old_system_client_user_id']

/* dev */						self_.logDev('Point Redemption', 'Getting item orders...', { clientUserId: clientUserId_ })

								return self_.$_debugExec_call('ipcFunction', 'getItemOrders', { clientUserId: clientUserId_ })
							}
						}).then(result => {
							if(self_.isEmpty(result)) {
/* dev */						self_.logDev('Point Redemption', 'item orders does not exist...', { uid: uid,  result: result })

								return Promise.resolve()
							} else {
/* dev */						self_.logDev('Point Redemption', 'Starting to move...', { uid: uid,  result: result })

								return new Promise((resolve, reject) => {
									result.forEach(itemOrderData => {
										promiseSequencePointRedemption_ = promiseSequencePointRedemption_.then(() => { return move_(itemOrderData) })
									})
									promiseSequencePointRedemption_ = promiseSequencePointRedemption_.then(() => resolve()).catch(error => reject(error))
								})
							}
						}).then(() => {
							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				const pointReturn_ = uid => {
					const move_ = itemOrderData => {
						return new Promise((resolve, reject) => {
							let pointRedemption_ = {}

							Promise.resolve().then(() => {
/* dev */						self_.logDev('Point Return (Moving)', 'Getting point redemptions...', { oldSystemItemOrderId: itemOrderData['id'] })

								return self_.$_debugExec_call('ipCliFunction', 'getPointRedemptions', { oldSystemItemOrderId: itemOrderData['id'] })
							}).then(result => {
								if(self_.isEmpty(result)) {
									reject('point redemptions does not exist.')
								} else {
									pointRedemption_ = result[0]

/* dev */							self_.logDev('Point Return (Moving)', 'Getting point returns...', { pointRedemptionId: pointRedemption_['id'] })

									return self_.$_debugExec_call('ipCliFunction', 'getPointReturns', { pointRedemptionId: pointRedemption_['id'] })
								}
							}).then(result => {
								const body_ = {
									uid: uid,
									amount: pointRedemption_['amount'],
									startDate: today_,
									endDate: oneYearFromToday_,
									pointRedemptionId: pointRedemption_['id'],
									description: null,
									oldSystemItemOrderId: pointRedemption_['old_system_item_order_id']
								}

								if(self_.isEmpty(result)) {
/* dev */							self_.logDev('Point Return (Moving)', 'Storing point returns...', { result: result, body: body_ })

									return self_.$_debugExec_call('ipCliFunction', 'postPointReturns', body_)
								} else {
/* dev */							self_.logDev('Point Return (Moving)', 'Updating point returns...', { result: result, body: body_ })

									// return self_.$_debugExec_callById('ipCliFunction', 'putPointReturns', result[0].id, body_)
									return Promise.resolve(result[0])
								}
							}).then(result => {
								result_.push('Finished: uid = ' + uid + ' / item order id = ' + itemOrderData['id'] + ' -> point return id = ' + result.id)
								resolve()
							}).catch(error => {
								reject(error)
							})
						})
					}

					let promiseSequencePointReturn_ = Promise.resolve()

					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
/* dev */					self_.logDev('Point Return', 'Getting app users...', { uid: uid })
							return self_.$_debugExec_call('ipCliFunction', 'getAppUsers', { uid: uid })
						}).then(result => {
							if(self_.isEmpty(result)) {
								reject('app user does not exist. (' + uid + ')')
							} else if(self_.isFalse(result[0]['old_system_client_user_id'])) {
/* dev */						self_.logDev('Point Return', 'app user does not have old system client user id...', { uid: uid, result: result })

								return Promise.resolve()
							} else {
								const clientUserId_ = result[0]['old_system_client_user_id']

/* dev */						self_.logDev('Point Return', 'Getting item orders...', { clientUserId: clientUserId_ })

								return self_.$_debugExec_call('ipcFunction', 'getItemOrders', { clientUserId: clientUserId_ })
							}
						}).then(result => {
							if(self_.isEmpty(result)) {
/* dev */						self_.logDev('Point Return', 'item orders does not exist...', { uid: uid,  result: result })

								return Promise.resolve()
							} else {
/* dev */						self_.logDev('Point Return', 'Starting to move...', { uid: uid,  result: result })

								return new Promise((resolve, reject) => {
									result.forEach(itemOrderData => {
										if(itemOrderData['cancel_status_id'] == 3 || itemOrderData['cancel_status_id'] == 4) {
											promiseSequencePointReturn_ = promiseSequencePointReturn_.then(() => { return move_(itemOrderData) })
										}
									})
									promiseSequencePointReturn_ = promiseSequencePointReturn_.then(() => resolve()).catch(error => reject(error))
								})
							}
						}).then(() => {
							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				const pointCancellation_ = uid => {
					const move_ = pointGivingData => {
						let pointGiving_ = {}

						return new Promise((resolve, reject) => {
							Promise.resolve().then(() => {
/* dev */						self_.logDev('Point Cancellation (Moving)', 'Getting point givings...', { oldSystemPointGivingId: pointGivingData['id'] })

								return self_.$_debugExec_call('ipCliFunction', 'getPointGivings', { oldSystemPointGivingId: pointGivingData['id'] })
							}).then(result => {
								if(self_.isEmpty(result)) {
									reject('point givings does not exist. (' + pointGivingData['id'] + ')')
								} else {
									pointGiving_ = result[0];

/* dev */							self_.logDev('Point Cancellation (Moving)', 'Getting point cancellations...', { oldSystemPointGivingId: pointGivingData['id'] })

									return self_.$_debugExec_call('ipCliFunction', 'getPointCancellations', { oldSystemPointGivingId: pointGivingData['id'] })
								}
							}).then(result => {
								const body_ = {
									uid: uid,
									amount: pointGiving_['amount'],
									startDate: pointGiving_['start_date'],
									endDate: endForever_,
									pointGivingId: pointGiving_['id'],
									description: null,
									oldSystemPointGivingId: pointGiving_['old_system_point_giving_id']
								}

								if(self_.isEmpty(result)) {
/* dev */							self_.logDev('Point Cancellation (Moving)', 'Storing point cancellations...', { result: result, body: body_ })

									return self_.$_debugExec_call('ipCliFunction', 'postPointCancellations', body_)
								} else {
/* dev */							self_.logDev('Point Cancellation (Moving)', 'Updating point cancellations...', { result: result, body: body_ })

									// return self_.$_debugExec_callById('ipCliFunction', 'putPointCancellations', result[0]['id'], body_)
									return Promise.resolve(result[0])
								}
							}).then(result => {
								result_.push('Finished: uid = ' + uid + ' / point cancellation id = ' + result.id)

								let updatedEndDate_ = null;
								if(pointGiving_['end_date'] > yesterday_) { updatedEndDate_ = yesterday_; }
								else { updatedEndDate_ = pointGiving_['end_date']}

								const body_ = {
									endDate: updatedEndDate_
								}

/* dev */						self_.logDev('Point Cancellation (Moving)', 'Updating point givings...', { id: pointGiving_['id'], body: body_ })

								return self_.$_debugExec_callById('ipCliFunction', 'putPointGivings', pointGiving_['id'], body_)
							}).then(result => {
								result_.push('Finished: uid = ' + uid + ' / point giving id = ' + result.id)
								resolve()
							}).catch(error => {
								reject(error)
							})
						})
					}

					let promiseSequencePointCancellation_ = Promise.resolve()

					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
/* dev */					self_.logDev('Point Cancellation', 'Getting app users...', { uid: uid })
							return self_.$_debugExec_call('ipCliFunction', 'getAppUsers', { uid: uid })
						}).then(result => {
							if(self_.isEmpty(result)) {
								reject('app user does not exist. (' + uid + ')')
							} else if(self_.isFalse(result[0]['old_system_client_user_id'])) {
/* dev */						self_.logDev('Point Cancellation', 'app user does not have old system client user id...', { uid: uid, result: result })

								return Promise.resolve()
							} else {
								const clientUserId_ = result[0]['old_system_client_user_id']

/* dev */						self_.logDev('Point Cancellation', 'Getting ipc point giving...', { clientUserId: clientUserId_ })

								return self_.$_debugExec_call('ipcFunction', 'getPointGiving', { clientUserId: clientUserId_ })
							}
						}).then(result => {
							if(self_.isEmpty(result)) {
/* dev */						self_.logDev('Point Cancellation', 'point giving does not exist...', { uid: uid,  result: result })

								return Promise.resolve()
							} else {
/* dev */						self_.logDev('Point Cancellation', 'Starting to move...', { uid: uid,  result: result })

								return new Promise((resolve, reject) => {
									result.forEach(pointGivingData => {
										if(pointGivingData['point_status_id'] == 4 || pointGivingData['point_status_id'] == 5) { // ccancelled
											promiseSequencePointCancellation_ = promiseSequencePointCancellation_.then(() => { return move_(pointGivingData) })
										}
									})
									promiseSequencePointCancellation_ = promiseSequencePointCancellation_.then(() => resolve()).catch(error => reject(error))
								})
							}
						}).then(() => {
							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				const pointExpiration_ = uid => {
					let sum_ = 0;
					let sumPointGivings_ = 0;
					let sumPointReturns_ = 0;
					let sumPointRedemptions_ = 0;
					let sumCancellations_ = 0;
					let sumExpirations_ = 0;
					let sumNotExpired_ = 0;
					let sumExpired_ = 0;

					const getPointGivings_ = () => {
						return new Promise((resolve, reject) => {
							Promise.resolve().then(() => {
/* dev */						self_.logDev('Point Expiration (Getting sum of point givings)', 'Start...', { uid: uid })

								return self_.$_debugExec_call('ipCliFunction', 'getPointGivings', { uid: uid })
							}).then(result => {
								if(!self_.isEmpty(result)) {
									result.forEach(data => {
										sumPointGivings_ += data.amount;
										if(data['end_date'] >= today_) { sumNotExpired_ += data.amount }
									})
								}

/* dev */						self_.logDev('Point Expiration (Getting sum of point givings)', 'Finished...', { uid: uid, sumPointGivings: sumPointGivings_, sumNotExpired: sumNotExpired_ })

								resolve()
							}).catch(error => {
								reject(error)
							})
						})
					}

					const getPointReturns_ = () => {
						return new Promise((resolve, reject) => {
							Promise.resolve().then(() => {
/* dev */						self_.logDev('Point Expiration (Getting sum of point returns)', 'Start...', { uid: uid })

								return self_.$_debugExec_call('ipCliFunction', 'getPointReturns', { uid: uid })
							}).then(result => {
								if(!self_.isEmpty(result)) {
									result.forEach(data => {
										sumPointReturns_ += data.amount;
									})
								}

/* dev */						self_.logDev('Point Expiration (Getting sum of point returns)', 'Finished...', { uid: uid, sumPointReturns: sumPointReturns_ })

								resolve()
							}).catch(error => {
								reject(error)
							})
						})
					}

					const getPointRedemptions_ = () => {
						return new Promise((resolve, reject) => {
							Promise.resolve().then(() => {
/* dev */						self_.logDev('Point Expiration (Getting sum of point redemptions)', 'Start...', { uid: uid })

								return self_.$_debugExec_call('ipCliFunction', 'getPointRedemptions', { uid: uid })
							}).then(result => {
								if(!self_.isEmpty(result)) {
									result.forEach(data => {
										sumPointRedemptions_ += data.amount;
									})
								}

/* dev */						self_.logDev('Point Expiration (Getting sum of point redemptions)', 'Finished...', { uid: uid, sumPointRedemptions: sumPointRedemptions_ })

								resolve()
							}).catch(error => {
								reject(error)
							})
						})
					}

					const getPointCancellations_ = () => {
						return new Promise((resolve, reject) => {
							Promise.resolve().then(() => {
/* dev */						self_.logDev('Point Expiration (Getting sum of point cancellations)', 'Start...', { uid: uid })

								return self_.$_debugExec_call('ipCliFunction', 'getPointCancellations', { uid: uid })
							}).then(result => {
								if(!self_.isEmpty(result)) {
									result.forEach(data => {
										sumCancellations_ += data.amount;
									})
								}

/* dev */						self_.logDev('Point Expiration (Getting sum of point cancellations)', 'Finished...', { uid: uid, sumCancellations: sumCancellations_ })

								resolve()
							}).catch(error => {
								reject(error)
							})
						})
					}

					const getPointExpirations_ = () => {
						return new Promise((resolve, reject) => {
							Promise.resolve().then(() => {
/* dev */						self_.logDev('Point Expiration (Getting sum of point expirations)', 'Start...', { uid: uid })

								return self_.$_debugExec_call('ipCliFunction', 'getPointExpirations', { uid: uid })
							}).then(result => {
								if(!self_.isEmpty(result)) {
									result.forEach(data => {
										sumExpirations_ += data.amount;
									})
								}

/* dev */						self_.logDev('Point Expiration (Getting sum of point expirations)', 'Finished...', { uid: uid, sumExpirations: sumExpirations_ })

								resolve()
							}).catch(error => {
								reject(error)
							})
						})
					}

					const expire_ = () => {
						return new Promise((resolve, reject) => {
							Promise.resolve().then(() => {
/* dev */						self_.logDev('Point Expiration', 'Getting sum...', { uid: uid })

								promiseArrayPointExpiration_.push(getPointGivings_())
								promiseArrayPointExpiration_.push(getPointReturns_())
								promiseArrayPointExpiration_.push(getPointRedemptions_())
								promiseArrayPointExpiration_.push(getPointCancellations_())
								promiseArrayPointExpiration_.push(getPointExpirations_())

								return Promise.all(promiseArrayPointExpiration_)
							}).then(() => {
								sum_ = sumPointGivings_ - sumPointRedemptions_ + sumPointReturns_ - sumCancellations_ - sumExpirations_;
								if(sum_ <= sumNotExpired_) {
/* dev */							self_.logDev('Point Expiration', 'no point to expire...', { sum: sum_, sumNotExpired: sumNotExpired_ })

									sumExpired_ = 0;
								} else {
									sumExpired_ = sum_ - sumNotExpired_;
								}
 
								const body_ = {
									uid: uid,
									amount: sumExpired_,
									startDate: today_,
									endDate: endForever_,
									description: null
								}

/* dev */						self_.logDev('Point Expiration', 'Storing point expirations...', { sum: sum_, sumNotExpired: sumNotExpired_, body: body_ })

								return self_.$_debugExec_call('ipCliFunction', 'postPointExpirations', body_)
							}).then(() => {
								return getPointExpirations_()
							}).then(() => {
/* dev */						self_.logDev('Point Expiration ', 'Getting app user point data...', { uid: uid })

								return self_.$_debugExec_call('ipCliFunction', 'getAppUserPointData', { uid: uid })
							}).then(result => {
								const body_ = {
									uid: uid,
									pointGivingAmount: sumPointGivings_,
									pointRedemptionAmount: sumPointRedemptions_,
									pointReturnAmount: sumPointReturns_,
									pointCancellationAmount: sumCancellations_,
									pointExpirationAmount: sumExpirations_
								}

								if(self_.isEmpty(result)) {
/* dev */							self_.logDev('Point Expiration', 'Storing app user point data...', { result: result, body: body_ })

									return self_.$_debugExec_call('ipCliFunction', 'postAppUserPointData', body_)
								} else {
/* dev */							self_.logDev('Point Expiration', 'Updating app user point data...', { result: result, body: body_ })

									return self_.$_debugExec_callById('ipCliFunction', 'putAppUserPointData', result[0]['id'], body_)
								}
							}).then(() => {
								resolve()
							}).catch(error => {
								reject(error)
							})
						})

					}

					let promiseArrayPointExpiration_ = []

					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
/* dev */					self_.logDev('Point Expiration', 'Getting point expirations...', { uid: uid, startDate: today_ })

							return self_.$_debugExec_call('ipCliFunction', 'getPointExpirations', { uid: uid, startDate: today_ })
						}).then(result => {
							if(!self_.isEmpty(result)) {
/* dev */						self_.logDev('Point Expiration', 'point expiration is already finished...', { uid: uid, todya: today_ })
								
								return Promise.resolve()
							} else {
								return expire_()
							}
						}).then(() => {
							result_.push('Finished: uid = ' + uid)

							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				let promiseSequence_ = Promise.resolve()

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
/* dev */				self_.logDev('Move Point To Laravel', 'Getting app users...')

						return self_.$_debugExec_call('ipCliFunction', 'getAppUsers', {})
					}).then(result => {
						return new Promise((resolve, reject) => {
							Object.keys(data_).forEach(type => {
								let users_ = data_[type]
								if(self_.isEmpty(users_)) {
									result.forEach(user => {
										users_.push(user.uid)
									})
								}

/* dev */						self_.logDev('Move Point To Laravel', 'Staring...', { users: users_ })

								users_.forEach(uid => {
									if(type == 'pointGiving') { promiseSequence_ = promiseSequence_.then(() => { return pointGiving_(uid) })}
									if(type == 'pointRedemption') { promiseSequence_ = promiseSequence_.then(() => { return pointRedemption_(uid) })}
									if(type == 'pointReturn') { promiseSequence_ = promiseSequence_.then(() => { return pointReturn_(uid) })}
									if(type == 'pointCancellation') { promiseSequence_ = promiseSequence_.then(() => { return pointCancellation_(uid) })}
									if(type == 'pointExpiration') { promiseSequence_ = promiseSequence_.then(() => { return pointExpiration_(uid) })}
								})
							})
							promiseSequence_ = promiseSequence_.then(() => resolve()).catch(error => reject(error))
						})
					}).then(() => {
						self_.setDebugState('result', result_)
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			debugRunGPU() {
				const self_ = this;

				const data_ = self_.getDebugState('data')

				return new Promise(resolve => {
/* dev */			self_.logDev('Run GPU', 'Started...', { data: data_ })

					const result_ = self_.gpuRun(100)

/* dev */			self_.logDev('Run GPU', 'Finished...', { result: result_ })

					self_.setDebugState('result', [result_])

					resolve()
				})
			},
			debugSetMenuItemsFromMenus() {
				const self_ = this;

				const set_ = (key, doc) => {
					return self_.setFirestoreSubDocument('contents', 'app', 'menuItems', key, doc)
				}

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.getFirestoreSubCollection('contents', 'app', 'menus')
					}).then(result => {
						let promiseArray_ = []
						Object.keys(result).forEach(key => {
							promiseArray_.push(set_(key,result[key]))
						})
						return Promise.all(promiseArray_)
					}).then(() => {
						self_.setDebugState('result', ['finished'])

						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			$_debugExec_call(functionType, functionName, body) {
				const self_ = this;

				// body.env = self_.env; // comment this out for live database

				return self_.callFunction(functionType, functionName, { body: body })	
			},
			$_debugExec_callById(functionType, functionName, id, body) {
				const self_ = this;

				// body.env = self_.env; // comment this out for live database

				return self_.callFunction(functionType, functionName, { id: id, body: body })	
			}
		}
	}
</script>